import { AudienceCatalogScreen } from "types";
import { createScreen } from "utils/createScreen";

const CreateAudienceDefinition = createScreen({
  name: AudienceCatalogScreen,
  path: "/audience-catalog/create",
  routePath: ["/create"],
  accessPath: "audienceCatalog",
});

export { CreateAudienceDefinition };
